import {
  Component, OnInit,
  ViewEncapsulation
} from '@angular/core';
import { UserService } from '../../../../services/user.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-colabs-autoupdate',
  templateUrl: './colabs-autoupdate.component.html',
  encapsulation: ViewEncapsulation.None
})

export class ColabsAutoUpdateComponent implements OnInit {
  public companyId: string;
  public apiDocumentation: string;

  constructor(private userService: UserService) {}

  ngOnInit() {
    const loggedAccount = this.userService.getLoggedAccount();
    this.companyId = loggedAccount && loggedAccount.id;
    this.apiDocumentation = environment.API_DOCUMENTATION;
  }

}
